import { render, staticRenderFns } from "./CreateCampaings.vue?vue&type=template&id=292f4162&scoped=true&"
import script from "./CreateCampaings.vue?vue&type=script&lang=ts&"
export * from "./CreateCampaings.vue?vue&type=script&lang=ts&"
import style0 from "./CreateCampaings.vue?vue&type=style&index=0&id=292f4162&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292f4162",
  null
  
)

export default component.exports